import { type InputFieldProps } from '../../../../../components/fields/InputNumberField';
import SelectField, { type SelectFieldProps } from '../../../../../components/fields/SelectField';
import FormFields from '../../../../../themes/admin/Fields/FormFields';
import { useFinanceProductDetailContext } from '../../FinanceProductDetailContext';
import useFinanceProductOptions from '../../shared/useFinanceProductOptions';

type DefaultIntervalFieldProps = Omit<InputFieldProps, 'addonAfter'> & {
    // props for unit
    unitProps: Omit<SelectFieldProps, 'options'>;
};

const DefaultIntervalField = ({ unitProps, ...props }: DefaultIntervalFieldProps) => {
    const { bank } = useFinanceProductDetailContext();

    const { amountUnitOptions } = useFinanceProductOptions(bank?.module?.company?.id);

    return (
        <FormFields.InputNumberField
            {...props}
            addonAfter={<SelectField {...unitProps} itemProps={{ noStyle: true }} options={amountUnitOptions} />}
        />
    );
};

export default DefaultIntervalField;
